import { useGetIdentity } from "@refinedev/core";

import type { CurrentUser } from "@/lib/providers";

/** Кто вошёл — единственный вход к `/api/me` на экранах; свежесть — минуты. */
export function useIdentity() {
  return useGetIdentity<CurrentUser>({ queryOptions: { staleTime: 5 * 60_000 } });
}
